import { render } from "./product-grid-simple.vue?vue&type=template&id=00034394"
import script from "./product-grid-simple.vue?vue&type=script&lang=js"
export * from "./product-grid-simple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__